import React from 'react';

import Checkbox from 'components/Checkbox';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import { intlGet } from 'utils/intlGet';
import { ResponsiveProps } from './models';
import styles from './styles.module.scss';

const Responsive: React.FunctionComponent<ResponsiveProps> = (props) => {
  const { responsive, toggleResponsive, dataTestId = 'responsive' } = props;
  const description = intlGet('EditorToolbar.Responsive', responsive ? 'ColumnsOneBelowTheOther' : 'ColumnsInOneRow');

  return (
    <Dropdown className={styles.Responsive} stopClickPropagation={true} dataTestId={`${dataTestId}-dropdown`}>
      <Checkbox
        onChange={toggleResponsive}
        checked={responsive}
        label={intlGet('EditorToolbar.Responsive', 'ResponsiveLayout')}
        dataTestId={`${dataTestId}-checkbox`}
      />
      <div className={styles.description} data-testid={`${dataTestId}-description`}>
        {description}
      </div>
    </Dropdown>
  );
};

export default Responsive;
